import { initialState } from './initialState';
import { appendPage, createReducer, pagedRequestCases } from './requestState';

export default createReducer(initialState, {
  ...pagedRequestCases('GET_SURVEY_HISTORY', 'historyRequestIds', {
    success: appendPage('survay_history_data', 'totalSurveysHistory'),
  }),
  RESET_SURVEY_HISTORY: state => ({
    ...state,
    survay_history_data: [],
    totalSurveysHistory: null,
    historyRequestIds: [],
  }),
});
